import { useTranslation } from "react-i18next";
import { Grid, Paper, Typography, Modal } from "@material-ui/core";

import { Form, Button, InputGroup } from "react-bootstrap";
import { useState } from "react";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { formatTime } from "../../utils/function";

const CreatePassword = (props) => {
  const { t } = useTranslation();
  const [showPwd, setShowPwd] = useState(false);
  const [showConfirmPwd, setShowConfirmPwd] = useState(false);
  const [pwdError, setPwdError] = useState(false);
  const [confirmPwdError, setConfirmPwdError] = useState(false);

  const validate = () => {
    let isValid = true;
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&?*]).{8,}$/;

    setPwdError("");
    setConfirmPwdError("");

    if (!props?.formValue?.password) {
      isValid = false;
      setPwdError(t("Please enter a password"));
    } else if (!passwordRegex.test(props?.formValue?.password)) {
      isValid = false;
      setPwdError(
        t(
          "Password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special character (e.g. !, @, #, $, %, ^, &, *)"
        )
      );
    }

    if (!props?.formValue?.confirmPassword) {
      isValid = false;
      setConfirmPwdError(t("Please confirm your password"));
    } else if (
      props?.formValue?.password !== props?.formValue?.confirmPassword
    ) {
      isValid = false;
      setConfirmPwdError(t("Password and confirm password do not match"));
    }

    return isValid;
  };

  const handlePasswordToggle = (value) => {
    if (value === "showPwd") {
      setShowPwd(!showPwd);
    }
    if (value === "showConfirmPwd") {
      setShowConfirmPwd(!showConfirmPwd);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      props.handleCreatePassword();
    }
  };

  return (
    <Modal
      open={props.passwordMode === "create"}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      backdrop="static"
    >
      <div className="centered-modal">
        <Form onSubmit={(e) => handleSubmit(e)}>
          <Grid container direction="column" alignItems="center">
            <Grid item xs className="password-modal">
              <Paper className="paper password-body" square>
                <Grid container direction="column" alignItems="center">
                  <Grid item lg>
                    <Typography variant="h4">
                      {t("Create your password")}
                    </Typography>
                  </Grid>
                  <Grid item sm xs={12} className="password-info">
                    <Typography variant="h6">
                      {t("Create a strong password to secure your account")}
                    </Typography>
                    <Typography variant="p">
                      {t(
                        "Password should contain at least 8 characters, 1 uppercase and 1 lowercase letter, as well as number and symbol (such as !, @, #, $, %, ^, & or *)"
                      )}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} className="form-container">
                    <Form.Group>
                      <Form.Label>{t("Password")} *</Form.Label>
                      <InputGroup>
                        <Form.Control
                          name="password"
                          type={showPwd ? "text" : "password"}
                          value={props?.formValue?.password}
                          onChange={props.handleChange}
                          id="password"
                          className="text-center"
                          autoComplete="new-password"
                          autoFocus
                          style={{ direction: "ltr" }}
                        />
                        <span
                          onClick={() => handlePasswordToggle("showPwd")}
                          className="eye-icon"
                        >
                          {showPwd ? (
                            <VisibilityOffOutlinedIcon />
                          ) : (
                            <RemoveRedEyeOutlinedIcon />
                          )}
                        </span>
                      </InputGroup>
                      {pwdError && (
                        <span className="errorsmg">{t(`${pwdError}`)}</span>
                      )}
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>{t("Confirm Password")} *</Form.Label>
                      <InputGroup>
                        <Form.Control
                          name="confirmPassword"
                          type={showConfirmPwd ? "text" : "password"}
                          value={props?.formValue?.confirmPassword}
                          onChange={props.handleChange}
                          id="confirmPassword"
                          className="text-center"
                          autoComplete="new-password"
                          style={{ direction: "ltr" }}
                        />
                        <span
                          className="eye-icon"
                          onClick={() => handlePasswordToggle("showConfirmPwd")}
                        >
                          {showConfirmPwd ? (
                            <VisibilityOffOutlinedIcon />
                          ) : (
                            <RemoveRedEyeOutlinedIcon />
                          )}
                        </span>
                      </InputGroup>
                      {confirmPwdError && (
                        <span className="errorsmg">
                          {t(`${confirmPwdError}`)}
                        </span>
                      )}
                    </Form.Group>
                  </Grid>
                  <Grid container direction="column" alignItems="center">
                    <Grid
                      item
                      xs
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        margin: "10px",
                      }}
                    >
                      <Button
                        type="submit"
                        className="submit"
                        style={{ maxWidth: "190px", margin: "0px auto" }}
                      >
                        {t("Submit")}
                      </Button>
                      <Typography variant="h6">
                        {props.passowrdTimer ? (
                          <span>{formatTime(props.passowrdTimer)}</span>
                        ) : (
                          t("")
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Form>
      </div>
    </Modal>
  );
};
export default CreatePassword;
